import { getPatternDefForPage } from './router-config/routerConfig'
import { DYNAMIC_PAGE_TYPES } from './dynamicPageTypes'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { PageRef } from '@wix/editor-platform-sdk-types'
import type { DynamicPageType } from './dynamicPageTypes'
import type { RouterConfig } from './router-config/routerConfigTypes'

export const getPageTypeFromPattern = (pattern: string): DynamicPageType =>
  pattern.includes('{')
    ? DYNAMIC_PAGE_TYPES.ITEM_PAGE
    : DYNAMIC_PAGE_TYPES.INDEX_PAGE

export async function getTypeOfProbableDynamicPage({
  editorSdkProxy,
  pageRef,
}: {
  editorSdkProxy: EditorSDK
  pageRef: PageRef
}): Promise<DynamicPageType | undefined> {
  const routerRef = await editorSdkProxy.routers.getByPage({ pageRef })
  if (!routerRef) {
    return
  }

  const routerData = await editorSdkProxy.routers.get<RouterConfig>({
    routerRef,
  })
  if (
    !routerData ||
    !routerData.config ||
    !routerData.config.patterns ||
    !Array.isArray(routerData.pages)
  ) {
    return
  }

  const { pattern } = getPatternDefForPage(
    routerData.config,
    routerData.pages,
    pageRef,
  )
  if (!pattern) {
    return
  }

  return getPageTypeFromPattern(pattern)
}
